import filter from 'underscore'

KCVS.Views.InformativeTooltip =
  template: JST['informative_fields/informative_tooltip']()
  props: ['fieldName', 'filterValue', 'customClass', 'placement']

  mounted: ->
    element = $("[data-input-field=#{@fieldName}]")[0]
    if @customClass
      element.classList.add("#{@customClass}")
    if @placement
      element.setAttribute('data-placement', @placement)
    @.$nextTick ->
      @updateTooltipContent()


  methods:
    updateTooltipContent: ->
      fieldName = @fieldName
      element = $("[data-input-field=#{fieldName}]")[0]
      if @filterValue != ''
        filterValue = @filterValue
        informativeField = @$store.state.informativeFields.filter (field) ->
          if field.filter == "no_filter"
            field.input_field_name == fieldName
          else
            field.input_field_name == fieldName and field.filter_value == filterValue
        [0]
        if informativeField[0] && informativeField[0].code != '' && informativeField[0].description != '' && informativeField[0].show_field
          tooltipContent = "#{informativeField[0].code}:\n#{informativeField[0].description}"
          element.style.display = ''
          element.setAttribute('data-original-title', tooltipContent)
          $('[data-toggle="tooltip"]').tooltip()
        else
          element.setAttribute('data-original-title', '')
          element.style.display = 'none'
      else
        informativeField = @$store.state.informativeFields.filter (field) ->
          field.input_field_name == fieldName
        [0]
        if informativeField[0] && informativeField[0].code != '' && informativeField[0].description != '' && informativeField[0].show_field
          tooltipContent = "#{informativeField[0].code}:\n#{informativeField[0].description}"
          element.style.display = ''
          element.setAttribute('data-original-title', tooltipContent)
          $('[data-toggle="tooltip"]').tooltip()
        else
          element.setAttribute('data-original-title', '')
          element.style.display = 'none'
